import { useRoutes } from 'react-router';
import { routes } from './routes';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import '@/styles/globals.css';

/**
 * Main application component
 * Sets up routing and error boundary
 */
function App() {
  const element = useRoutes(routes);

  return (
    <ErrorBoundary>
      {element}
    </ErrorBoundary>
  );
}

export default App;
